'use client';

import React from 'react';

export interface IdeaBankItem {
  id: string;
  title: string;
  objective: string;
  sector: string | null;
  tipo: string | null;
  impacto: string[] | null;
  innovacion: string | null;
  modelo: string | null;
  status: 'pending' | 'diagnosing' | 'completed';
  created_at: string;
}

const STATUS_BADGE = {
  pending: null,
  diagnosing: { label: 'En diagnóstico', color: 'bg-amber-500/20 text-amber-300 border-amber-500/30' },
  completed: { label: 'Completada', color: 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30' },
};

interface Props {
  idea: IdeaBankItem;
  index: number;
  onClick: (idea: IdeaBankItem) => void;
}

export default function IdeaCard({ idea, index, onClick }: Props) {
  const tags = [idea.sector, idea.tipo, idea.modelo, idea.innovacion, ...(idea.impacto ?? [])].filter(Boolean) as string[];
  const badge = STATUS_BADGE[idea.status];

  return (
    <button
      type="button"
      onClick={() => onClick(idea)}
      className="group w-full text-left bg-white/5 hover:bg-white/10 backdrop-blur-sm border border-white/10 hover:border-white/25 rounded-2xl p-5 transition-all duration-200 hover:shadow-lg hover:shadow-purple-900/20 hover:-translate-y-0.5"
    >
      <div className="flex items-start justify-between gap-3 mb-3">
        <div className="flex items-center gap-2 flex-shrink-0">
          <span className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-500 to-pink-500 flex items-center justify-center text-white text-xs font-bold flex-shrink-0">
            {index + 1}
          </span>
          {badge && (
            <span className={`text-xs px-2 py-0.5 rounded-full border font-medium ${badge.color}`}>
              {badge.label}
            </span>
          )}
        </div>
        <span className="text-white/30 group-hover:text-white/60 transition-colors text-lg">→</span>
      </div>

      <h3 className="text-white font-semibold text-base leading-snug mb-2 group-hover:text-orange-200 transition-colors">
        {idea.title}
      </h3>
      <p className="text-white/60 text-sm leading-relaxed line-clamp-2">
        {idea.objective}
      </p>

      {tags.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mt-3">
          {tags.slice(0, 4).map((tag) => (
            <span key={tag} className="text-xs px-2 py-0.5 rounded-full bg-white/5 border border-white/8 text-white/40">
              {tag}
            </span>
          ))}
        </div>
      )}
    </button>
  );
}
